"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"
import { ShelfItemBookEntity } from "@/app/entities/ShelfEntity"

const ROOT = process.env.NEXT_PUBLIC_ROOT

export type BookShelfAnalyzePollingResponse = ShelfItemBookEntity[]

const fetchClientBookShelfAnalyzePolling = (analysisId: string) =>
  fetchInterceptorInClient(
    {
      method: "post",
    },
    ROOT,
  )(() => `/api/shelf/shelf-analyze/${analysisId}/polling`).then(
    resultPostprocessing2<BookShelfAnalyzePollingResponse>,
  )

export default fetchClientBookShelfAnalyzePolling
